function resizeWells (selector) {
    var elementsToChange = [];
    var elementsChanged = [];

    var maxHeight = 0;
    jQuery(selector).each(function (index, value) {
        jQuery(value).css('minHeight', 'auto');

        if (maxHeight < jQuery(value).outerHeight()) {
            maxHeight = jQuery(value).outerHeight();
            elementsToChange = elementsChanged;
        }

        jQuery(value).css('minHeight', maxHeight );

        elementsChanged.push(jQuery(value));
    });

    elementsToChange.forEach(function (element) {
        element.css('minHeight', maxHeight );
    });
}

function emptySearch () {
	if( !jQuery('.search-input').val() ) {
		jQuery('.search-submit').prop('disabled',true);
	} else {
		jQuery('.search-submit').prop('disabled',false);
	}
}

function CaptchaCallback() {
	jQuery('.g-recaptcha').each(function(index, el) {
        grecaptcha.render(el, {'sitekey' : '6LcU3g0TAAAAAL06dSK6YzDiSrQaCK0M0Y7ptxKS'});
    });
}

function resizeServices() {

}

(function ($, root, undefined) {

	$(function () {

		'use strict';

		var img = $('.recent-projects li a.active').attr('data-img');
		$('.recent-projects-img img').attr('src',img);

		$('.recent-projects li a').mouseover(function() {
			$('.recent-projects li a').removeClass('active');
			$(this).addClass('active');
			var img = $(this).attr('data-img');
			$('.recent-projects-img img').attr('src',img);
		});

		var boxWidth = $('.overlay-box a').outerWidth();
		$('.overlay-box a').css('height',boxWidth);
		$(window).resize(function() {
			var boxWidth = $('.overlay-box a').outerWidth();
			$('.overlay-box a').css('height',boxWidth);
		});

		$("#mobile-menu").mmenu({
           "offCanvas": {
              "position": "right"
           }
        });

		var galleryHeight = $('.project-gallery-main').height();
        $('.project-gallery-item img').click(function() {
            var parent = $(this).parents('.col-xs-3').index();
            parent++;
            var mainPosition = '.project-gallery-main a:nth-of-type('+parent+') img';
            $('.project-gallery-main img').hide();
            $(mainPosition).show();

        });

        $('.affiliates-item img').mouseenter(function() {
            var colorSrc = $(this).data('colour');
            var monoSrc = $(this).data('mono');
            $(this).attr('src',colorSrc);
        }).mouseleave(function() {
            var colorSrc = $(this).data('colour');
            var monoSrc = $(this).data('mono');
            $(this).attr('src',monoSrc);
        });


        $('.mm-listview .menu-item-has-children a:nth-of-type(2)').click(function(e) {
            e.preventDefault();
            $(this).prev().click();
        });
	});

})(jQuery, this);
